import { render } from "./BaseInfoCard.vue?vue&type=template&id=1c16373a&scoped=true"
import script from "./BaseInfoCard.vue?vue&type=script&lang=js"
export * from "./BaseInfoCard.vue?vue&type=script&lang=js"

import "./BaseInfoCard.vue?vue&type=style&index=0&id=1c16373a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c16373a"]])

export default __exports__